import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class AddHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		console.log('add menu', this.props);
		if(this.props.data.locked === false) {
			return(
				<ul className="menu">
					<li className="back"><Link id="toFeed" to="/">Return To Feed</Link></li>
				</ul>
			)
		} else if(this.props.data.post.length === 0) {
			return(
				<ul className="menu">
					<li><Link to="/add/location">Location</Link></li>
					<li><Link to="/add/content">Content</Link></li>
					<li className="back"><Link id="toFeed" to="/">Return To Feed</Link></li>
				</ul>
			)
		} else {

			return (
				<ul className="menu">
					<li><Link to="/add/location">Location</Link></li>
					<li><Link to="/add/post">Content</Link></li>
					<li><Link to="/add/profile">Profile</Link></li>
					<li><Link to="/add/publish">Publish</Link></li>
					<li className="back"><Link id="toFeed" to="/">Return To Feed</Link></li>
				</ul>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/add-menu.jsx